import { AppInitializationContext } from '../contexts/AppInitializationContext.tsx';
import { ReactNode, useEffect } from 'react';
import { useChannelsService } from '../hooks/useChannelsService.tsx';
import { useAuth } from '../hooks/useAuth.tsx';
import { useAccount } from '../hooks/account/useAccount.tsx';

interface IProps {
    children: ReactNode;
}

const AppInitializationProvider = ({ children }: IProps) => {
    const { isRefreshTokenAvailable } = useAuth();
    const { getChannels } = useChannelsService();
    const accountService = useAccount();
    const initialize = async () => {
        await getChannels();
        if (isRefreshTokenAvailable) {
            // await accountService.getMe();
        }
    };

    useEffect(() => {
        initialize();
    }, []);

    return (
        <AppInitializationContext.Provider value={{ initialize }}>
            {children}
        </AppInitializationContext.Provider>
    );
};

export default AppInitializationProvider;